module.exports = __webpack_public_path__ + "static/media/like.1ef3999d.svg";